/*
 * 商家service
 * */

import {
	POST
} from './service.config.js'
import md5 from 'js-md5'
import axios from "axios";


/**
 * 商家登录
 * @param shopTel 商家手机号
 * @param shopPass 商家密码
 * @param openid 微信openid
 * @returns {*|Promise<unknown>}
 */
export const shopLoginService = (shopTel, shopPass, openid) => POST('btrexchange/businessLogin', {
	tel: shopTel,
	password: md5(shopPass),
	openid,
});


/**
 * 商家修改登录密码
 * @param tel 电话
 * @param pass 密码
 * @param code 验证码
 * @returns {*|Promise|Promise<unknown>}
 */
export const shopChangePassService = (tel, pass, code) => POST('btrexchange/shopChangePassword', {
	tel,
	code,
	password: md5(pass),
});

/**
 * 获取商家信息
 * @param shopId
 * @returns {*|Promise<unknown>}
 */
export const getShopInfoService = shopId => POST('btrexchange/getShopInfo', {
	shop_id: shopId,
});


/**
 * 商家提现
 * @param shopId 商家ID
 * @param price 提现金额
 * @param pass 提现密码
 * @param openId
 * @returns {*|Promise|Promise<unknown>}
 */
export const setDoTxService = (shopId, price, pass, openId) => POST('btrexchange/doTx', {
	shop_id: shopId,
	amount: price,
	password: md5(pass),
	openid: openId,
	source_status: 1,

});


/**
 * 获取商家收款记录
 * @param shopId 商家ID
 * @param type 类型 0：付款记录 1:充值记录 2：余额消费 3：所有记录
 * @param page 当前页码
 * @param limit 每页显示行数
 * @param startDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise<unknown>}
 */
export const getShopRecordsListService = (shopId, type, page, limit, startDate, endDate) => POST('btrexchange/records', {
	shop_id: shopId,
	type,
	page,
	limit,
	source_status: 1, //标识公众号
	start_time: startDate,
	end_time: endDate,
});

/**
 * 获取商家提现记录
 * @param shopId 商家ID
 * @param page 当前页码
 * @param limit 每页显示行数
 * @param startDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopTXListSetvice = (shopId, page, limit, startDate, endDate) => POST('btrexchange/tx_record', {
	shop_id: shopId,
	page,
	limit,
	start_time: startDate,
	end_time: endDate,
});


/**
 * 查看商家的兑换记录
 * @param shopId 商家ID
 * @param page
 * @param limit
 * @param startDate 开始时间
 * @param limit 结束时间
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopExchangeListService = (shopId, page, limit, startDate, endDate) => POST('btrexchange/shopExchange', {
	shop_id: shopId,
	page,
	limit,
	source_status: 1, //标识公众号
	start_time: startDate,
	end_time: endDate,
});


/**
 * 获取商家锁客列表
 * @param shopId 商家ID
 * @param page
 * @param limit
 * @param startDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopLockGuestListService = (shopId, page, limit, startDate, endDate) => POST(
	'btrexchange/getLockGuestList', {
		shop_id: shopId,
		page,
		limit,
		source_status: 1, //标识公众号
		start_time: startDate,
		end_time: endDate,
	});

/**
 * 获取商家锁客提成列表
 * @param shopId 商家ID
 * @param page
 * @param limit
 * @param startDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopLockGuestTCListService = (shopId, page, limit, startDate, endDate) => POST(
	'btrexchange/getLockGuestTCList', {
		shop_id: shopId,
		page,
		limit,
		source_status: 1, //标识公众号
		start_time: startDate,
		end_time: endDate,
	});


/**
 * 修改商家提现密码
 * @param tel
 * @param pass
 * @param shopId
 * @param code
 * @returns {*|Promise|Promise<unknown>}
 */
export const shopChangePayPassService = (tel, pass, shopId, code) => POST('btrexchange/saveShopZfpass', {
	tel,
	shop_id: shopId,
	code,
	password: md5(pass),
});

/**
 * 商家退出登录
 * @type {*|Promise|Promise<unknown>}
 */
export const getOutService = shopId => POST('btrexchange/shopGetOut', {
	shop_id: shopId
});


/**
 * 获取附近商家
 * @param lat
 * @param lng
 * @param page
 * @param limit
 * @returns {*|Promise|Promise<unknown>}
 */
export const getCommunitysService = (lat, lng, page, limit, code, typeId) => POST('btrbasic/getCommunitys', {
	lat,
	lng,
	page,
	limit,
	search: code,
	cid: typeId,
});


/**
 * 获取商家详情
 * @param shopId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopDetailsService = shopId => POST('btrbasic/userGetShopInfo', {
	shop_id: shopId,
});

/**
 * 商家特殊服务详情
 * @param shopId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getNewShopGoodsDetail = (shopId, id) => POST('btrbasic/getNewShopGoodsDetail', {
	shop_id: shopId,
	id: id
});

/**
 * 获取商家统计信息
 * @param shopId
 * @param stareDate 开始时间
 * @param endDate 结束时间
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopStatisticsService = (shopId, stareDate, endDate) => POST('btrbasic/shopStatistics', {
	shop_id: shopId,
	start_time: stareDate,
	end_time: endDate,
});

/**
 * 上传图片
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const senImgService = data => {
	const config = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	};
	let formData = new FormData();
	formData.append('file', data);
	return new Promise((resolve, reject) => {
		axios.post('btrbasic/shop_file', formData, config).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	});

};

/**
 * 上传视频
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const sendVideoService = (data, shopId) => {
	const config = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	};
	let formData = new FormData();
	formData.append('file', data);
	formData.append('shopId', shopId);
	return new Promise((resolve, reject) => {
		axios.post('btrbasic/uploadShopVideo', formData, config).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	});

};

/**
 * 上传视频广场视频
 * @param data
 * @returns {Promise | Promise<unknown>}
 */
export const sendVideoLiveService = (data, shopId, cateid,title,img) => {
	const config = {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	};
	let formData = new FormData();
	formData.append('file', data);
	formData.append('shopId', shopId);
	formData.append('cateid', cateid);
	formData.append('title', title);
	formData.append('img', img);
	return new Promise((resolve, reject) => {
		axios.post('btrbasic/uploadShopVideoLive', formData, config).then(res => {
			resolve(res)
		}).catch(err => {
			reject(err)
		})
	});

};

export const sendIntroduceService = (shopId, text, imgArr) => POST('btrbasic/SaveShopInt', {
	shop_id: shopId,
	con_text: text,
	con_img_0: imgArr[0] || '',
	con_img_1: imgArr[1] || '',
	con_img_2: imgArr[2] || '',
	con_img_3: imgArr[3] || '',
	con_img_4: imgArr[4] || '',
	con_img_5: imgArr[5] || '',
	con_img_6: imgArr[6] || '',
	con_img_7: imgArr[7] || '',
	con_img_8: imgArr[8] || '',
	con_img_9: imgArr[9] || '',
});


/**
 * 获取商家上传详情
 * @param shopId
 * @returns {Promise | Promise<unknown>}
 */
export const getIntroduceService = shopId => POST('btrbasic/seeShopInfo', {
	shop_id: shopId,
});

/**
 * 商家活动信息上传
 * @param shopId
 * @returns {Promise | Promise<unknown>}
 */
export const addShopActivity = (shopId, title, content, imgArr, video) => POST('btrbasic/addShopActivity', {
	shop_id: shopId,
	title: title,
	content: content,
	img0: imgArr[0] || '',
	img1: imgArr[1] || '',
	img2: imgArr[2] || '',
	img3: imgArr[3] || '',
	img4: imgArr[4] || '',
	img5: imgArr[5] || '',
	video: video[0] || ''
});

/**
 * 获取商家活动详情
 * @param shopId
 * @returns {Promise | Promise<unknown>}
 */
export const getShopActivity = shopId => POST('btrbasic/getShopActivity', {
	shop_id: shopId,
});


/**
 * 活动详情获取
 * @param shopId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getShopActivityDetailsService = shopId => POST('btrbasic/getShopActivityDetails', {
	shop_id: shopId,
});

/**
 * 获取商家特色商品列表
 * @param shopId
 * @returns {*|Promise|Promise<unknown>}
 */
export const getMyShopGoodsListService = shopId => POST('newapi/getShopGoodsList', {
	shop_id: shopId,
});
